export default [
  {
    name: '简洁版',
    src: require('./style-one.png'),
    cardStyle: 1
  },
  {
    name: '素雅版',
    src: require('./style-two.png'),
    cardStyle: 2
  }, {
    name: '商务版',
    src: require('./style-three.png'),
    cardStyle: 3
  }
]
